import reducer from "./reducer";
export { default as Certificates } from "./components/index";
export { default as certificatesReducerName } from "./constants";
export default reducer;
